import { DiagramSnapshot } from 'src/containers/ProjectDiagram/types/diagram';
import { isResource } from 'src/containers/ProjectDiagram/utils/data';

export const getPreviousResource = (diagram: DiagramSnapshot, id: string) =>
  diagram.model.modelData.draftData?.prevNodeDataArray.find(
    (nodeData) => isResource(nodeData) && nodeData.value === id
  );
